'use client'

import { FacebookOutlined, Instagram, Pinterest } from '@mui/icons-material'
import { IconButton, Link } from '@mui/material'

export const SOCIAL_LINKS = [
  { href: 'https://www.instagram.com/marriagebiodatamaker.app', icon: Instagram },
  { href: 'https://www.facebook.com/marriagebiodatamakerapp', icon: FacebookOutlined },
  { href: 'https://in.pinterest.com/marriagebiodatamakerapp/', icon: Pinterest },
]
type Props = {
  color?: 'primary' | 'secondary'
}
const SocialLinks = ({ color = 'primary' }: Props) => {
  return (
    <>
      {SOCIAL_LINKS.map(({ href, icon: Icon }) => (
        <IconButton key={href} component={Link} href={href} target="_blank" rel="noopener" color={color}>
          <Icon />
        </IconButton>
      ))}
    </>
  )
}

export default SocialLinks
